import { render } from "./TimerPopup.vue?vue&type=template&id=3201f53a"
import script from "./TimerPopup.vue?vue&type=script&lang=js"
export * from "./TimerPopup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__